import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function CustomSelect({ label, value, data, onClick }) {
  const [sortedValue, setSortedValue] = React.useState("");

  // const handleChange = (event) => {
  //   setSortedValue(event.target.value);
  // };

  React.useEffect(() => {
    setSortedValue(value);
  }, [value]);
  return (
    <>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
        <InputLabel
          id="demo-simple-select-standard-label"
          className=" ont-Inter"
          sx={{ fontSize: "0.9rem" }} // Adjust the font size as needed
        >
          Sort By
        </InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={sortedValue}
          onChange={onClick}
          label="Sort By"
          sx={{ fontSize: "0.9rem" }} // Adjust the font size as needed
        >
          {/* <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Sort By</InputLabel>
        <Select
          labelId="demo-select-small-label"
          id="demo-select-small"
          value={value}
          label="Sort By"
          onChange={onClick}
        > */}
          {data.map((item, index) => (
            <MenuItem
              value={item}
              key={index}
              className="text-sm"
              sx={{ fontSize: "0.9rem" }} // Adjust the font size as needed
            >
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}
